import { createFileRoute } from '@tanstack/react-router'
import { requireAnyPermission } from '@/lib/permissions/route-guards'
import { BACKOFFICE_PREFIX } from '@/lib/permissions/backoffice-permissions'

/**
 * Layout route for the whole Backoffice (sc-1215).
 *
 * Gates on holding ANY Backoffice permission, which is the check the two hub
 * pages need — they have no key of their own. Each leaf then adds its own
 * specific requirement, so the two compose: this decides whether you belong in
 * the Backoffice at all, the leaf decides whether you belong on that page.
 *
 * Replaces the identical auth-plus-ADMIN block that used to be copy-pasted
 * into all eleven leaves.
 */
export const Route = createFileRoute('/_app/backoffice')({
  beforeLoad: requireAnyPermission(BACKOFFICE_PREFIX),
})
